import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export interface RecentSymptoms {
  /** Symptom IDs the user logged recently, most-frequent first. */
  symptoms: string[]
}

/**
 * Symptoms the user has been logging lately — used to carry them forward onto
 * the daily check-in so the usual ones are a single tap away.
 */
export function useRecentSymptoms(enabled = true) {
  return useQuery({
    queryKey: ['checkin', 'recent-symptoms'],
    queryFn: () => api.get<RecentSymptoms>('/api/checkin/recent-symptoms'),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
